module.exports = __webpack_public_path__ + "static/img/project01.eb63d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project01.jpg
// module id = SHXD
// module chunks = 1